import { render, staticRenderFns } from "./DetailServiceRetubing.vue?vue&type=template&id=509b239e&"
import script from "./DetailServiceRetubing.vue?vue&type=script&lang=js&"
export * from "./DetailServiceRetubing.vue?vue&type=script&lang=js&"
import style0 from "./DetailServiceRetubing.vue?vue&type=style&index=0&id=509b239e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports